// extracted by mini-css-extract-plugin
module.exports = {"iconAndTextGrouping":"AlertChip_iconAndTextGrouping__3gK9P","iconStyle":"AlertChip_iconStyle__Tbvv2"};